import actions from './auth_actions'
import state from './auth_state'
import getters from './auth_getters'
import mutations from './auth_mutations'
import cookies from '../../plugins/cookies'
const name = 'auth'

// OPTIONAL persistence function to load
// Typically just setting a persistence value is easiest
const load = () => {
    var local = JSON.parse(localStorage.getItem(name))
    // Checking internal value to prevent previous version's data
    // causing a false positive.
    if (local && local.token) {
        return local
    } else {
        return JSON.parse(cookies.get(name))
    }
}

export default {
    name,
    persistence: {
        load
        // save // this method would cause all mutations to trigger a persist action
    },
    getters,
    mutations,
    state,
    actions
}
